import React from 'react';

import i18n from '../../i18n';

// @mui
import { IconButton, TableCell, Typography } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

// Text, Number, Items editorCells are similar
export default class GridItemsCell extends React.Component {
    render() {
        // props: value, id, field
        const value = this.props.value ? this.props.value : '';
        const field = this.props.field;
        const row = this.props.row;
        const variant = field.variant || 'default';
        const extra =
            typeof field.extraRender === 'function'
                ? field.extraRender(value, row)
                : null;
        const enableCopyExtraRender = field.enableCopyExtraRender;

        const baseStyle = this.props.styles;
        const noTranslate = !!this.props.field.noTranslate;
        // As in DialogItemsField: field.enumGroup reads enums.<group>.<value>.
        const enumKey = field.enumGroup ? `enums.${field.enumGroup}.${value}` : `enums.${value}`;

        return (
            <TableCell
                key={this.props.field.id}
                align="left"
                sx={{ ...baseStyle }}
            >
                {variant === 'default' && (
                    <Typography variant="body2" component="div">
                        {noTranslate
                            ? value
                            : value
                                ? i18n.t(enumKey)
                                : ''}
                    </Typography>
                )}
                {extra && (
                    <Typography variant="body2" component="div">
                        {extra}
                        {enableCopyExtraRender && (
                            <IconButton
                                size="small"
                                onClick={() =>
                                    navigator.clipboard.writeText(extra)
                                }
                                sx={{
                                    "padding": '0 0 0 2px',
                                    "width": '16px',
                                    "height": '16px',
                                    "color": 'text.secondary',
                                    '& svg': { fontSize: '1rem' }
                                }}
                            >
                                <ContentCopy fontSize="inherit" />
                            </IconButton>
                        )}
                    </Typography>
                )}
                {variant === 'reversed' && (
                    <Typography variant="body2" component="div">
                        {noTranslate
                            ? value
                            : value
                                ? i18n.t(enumKey)
                                : ''}
                    </Typography>
                )}
            </TableCell>
        );
    }
}
